import React from "react";
import authProvider from "../../modules/auth/authProvider";
import ResetPasswordScreen from "./ResetPasswordScreen";

const ResetPasswordScreenContainer: React.FunctionComponent = () => {
  return <ResetPasswordScreen authProvider={authProvider} />;
};

export default ResetPasswordScreenContainer;
